/* 0511ER — v8: Warenkorb-Drawer, AJAX, Versand-Fortschritt, Set-Upgrade, eine Empfehlung (Logik aus v7.1 übernommen) */
(function () {
  'use strict';

  var cfgEl = document.getElementById('warenkorb-config');
  var drawer = document.querySelector('[data-drawer]');
  if (!cfgEl || !drawer) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = cfg.t || {};

  var elItems = drawer.querySelector('[data-drawer-items]');
  var elProgress = drawer.querySelector('[data-drawer-progress]');
  var elUpsell = drawer.querySelector('[data-drawer-upsell]');
  var elTotal = drawer.querySelector('[data-drawer-total]');
  var elShip = drawer.querySelector('[data-drawer-shipnote]');
  var giftId = cfg.giftVariant ? parseInt(cfg.giftVariant, 10) : 0;
  var busy = false;

  /* ── Geld formatieren nach Shop-Format ── */
  function money(cents) {
    var fmt = cfg.moneyFormat || '{{amount_with_comma_separator}} €';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var thousands = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return thousands(parts[0], '.') + ',' + parts[1];
      if (k === 'amount_no_decimals') return thousands(parts[0], '.');
      if (k === 'amount_no_decimals_with_comma_separator') return thousands(parts[0], '.');
      return thousands(parts[0], ',') + '.' + parts[1];
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200'; }
  function fill(tpl, amount) { return String(tpl || '').replace('[betrag]', amount); }

  /* ── Drawer öffnen / schließen ── */
  function open() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.querySelectorAll('[data-open-cart]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); refresh().then(open); });
  });

  /* ── API ── */
  function api(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function getCart() { return api('/cart.js'); }

  /* ── Beigabe automatisch hinzufügen / entfernen ── */
  function subtotalOhneBeigabe(cart) {
    var sum = 0;
    cart.items.forEach(function (i) { if (i.variant_id !== giftId) sum += i.final_line_price; });
    return sum;
  }
  function syncGift(cart) {
    if (!giftId || !cfg.giftFrom) return Promise.resolve(cart);
    var line = cart.items.find(function (i) { return i.variant_id === giftId; });
    var ok = subtotalOhneBeigabe(cart) >= cfg.giftFrom && cart.items.some(function (i) { return i.variant_id !== giftId; });
    if (ok && !line) {
      return api('/cart/add.js', { items: [{ id: giftId, quantity: 1, properties: { _beigabe: '1' } }] }).then(getCart).catch(function () { return cart; });
    }
    if (!ok && line) {
      return api('/cart/change.js', { id: line.key, quantity: 0 });
    }
    if (ok && line && line.quantity > 1) {
      return api('/cart/change.js', { id: line.key, quantity: 1 });
    }
    return Promise.resolve(cart);
  }

  /* ── Rendern ── */
  function renderProgress(cart) {
    var sub = subtotalOhneBeigabe(cart);
    var html = '';
    if (cfg.freeFrom > 0 && cart.item_count > 0) {
      var restV = cfg.freeFrom - sub;
      var pV = Math.min(100, Math.round(sub / cfg.freeFrom * 100));
      html += '<div class="progress-row"><p>' + (restV > 0 ? fill(T.freeMissing, '<strong>' + money(restV) + '</strong>') : T.freeReached) + '</p>' +
        '<div class="progress-bar"><span style="width:' + pV + '%"></span></div></div>';
    }
    if (giftId && cfg.giftFrom > 0 && sub >= (cfg.freeFrom || 0)) {
      var restG = cfg.giftFrom - sub;
      var pG = Math.min(100, Math.round(sub / cfg.giftFrom * 100));
      var name = esc(cfg.giftTitle) + (cfg.giftValue ? ' (' + esc(cfg.giftValue) + ')' : '');
      html += '<div class="progress-row"><p>' + (restG > 0 ? fill(T.giftMissing, '<strong>' + money(restG) + '</strong>').replace('[beigabe]', name) : T.giftReached.replace('[beigabe]', name)) + '</p>' +
        '<div class="progress-bar"><span style="width:' + pG + '%"></span></div></div>';
    }
    elProgress.innerHTML = html;
    elProgress.hidden = !html;

    if (elShip) {
      var frei = !cfg.freeFrom || sub >= cfg.freeFrom;
      elShip.textContent = frei ? T.shipFree : fill(T.shipCost, cfg.shipCost || '');
    }
  }

  function renderItems(cart) {
    if (!cart.item_count) {
      elItems.innerHTML = '<p class="drawer-empty">' + esc(T.empty) + '</p>';
      return;
    }
    elItems.innerHTML = cart.items.map(function (i) {
      var gift = i.variant_id === giftId;
      var opts = (i.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' · ');
      var img = i.featured_image && i.featured_image.url ? sized(i.featured_image.url) : '';
      return '<div class="line" data-key="' + esc(i.key) + '">' +
        '<a href="' + esc(i.url) + '" class="line-img">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(i.product_title) + '" width="80" height="100" loading="lazy">' : '') + '</a>' +
        '<div class="line-info">' +
          '<a href="' + esc(i.url) + '" class="line-title">' + esc(i.product_title) + '</a>' +
          (opts ? '<span class="line-opts">' + opts + '</span>' : '') +
          (gift ? '<span class="line-gift">' + esc(T.gift) + '</span>' :
            '<div class="line-qty">' +
              '<button type="button" data-qty="' + (i.quantity - 1) + '" aria-label="−">−</button>' +
              '<span>' + i.quantity + '</span>' +
              '<button type="button" data-qty="' + (i.quantity + 1) + '" aria-label="+">+</button>' +
              '<button type="button" class="line-remove" data-qty="0">' + esc(T.remove) + '</button>' +
            '</div>') +
        '</div>' +
        '<span class="line-price">' + (i.final_line_price === 0 ? esc(T.gift) : money(i.final_line_price)) + '</span>' +
      '</div>';
    }).join('');
  }

  /* ── Eine Empfehlung (nur wenn kein Set-Upgrade passt) ── */
  var upsellFor = null;
  function renderUpsell(cart) {
    var base = cart.items.find(function (i) { return i.variant_id !== giftId; });
    if (!base) { elUpsell.hidden = true; upsellFor = null; return; }
    if (upsellFor === base.product_id + ':' + cart.item_count) return;
    upsellFor = base.product_id + ':' + cart.item_count;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    fetch('/recommendations/products.json?product_id=' + base.product_id + '&limit=6&intent=complementary')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var p = (data.products || []).find(function (x) { return x.available && inCart.indexOf(x.id) === -1 && x.variants[0].id !== giftId; });
        if (!p) { elUpsell.hidden = true; return; }
        var variants = p.variants.filter(function (v) { return v.available; });
        var select = variants.length > 1 ?
          '<select data-upsell-variant aria-label="' + esc(T.size) + '">' + variants.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>' :
          '<input type="hidden" data-upsell-variant value="' + variants[0].id + '">';
        var img = p.featured_image ? sized(p.featured_image) : '';
        elUpsell.innerHTML = '<span class="kicker">' + esc(T.upsell) + '</span>' +
          '<div class="upsell">' +
            (img ? '<a href="' + esc(p.url) + '" class="line-img"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="80" height="100" loading="lazy"></a>' : '') +
            '<div class="line-info"><a href="' + esc(p.url) + '" class="line-title">' + esc(p.title) + '</a><span class="line-opts">' + money(p.price) + '</span>' +
            '<div class="upsell-add">' + select + '<button type="button" class="btn btn-ghost" data-upsell-add>' + esc(T.add) + '</button></div></div>' +
          '</div>';
        elUpsell.hidden = false;
      })
      .catch(function () { elUpsell.hidden = true; });
  }

  /* ── Set-Upgrade: aus einem Einzelteil im Warenkorb ein Set machen ── */
  var elSet = drawer.querySelector('[data-drawer-set]');
  var SETS = [];
  try { SETS = JSON.parse(document.getElementById('set-daten').textContent).filter(Boolean); } catch (e) {}
  var upgrade = null;

  function sizeOf(line) {
    var o = (line.options_with_values || []).find(function (x) { return /gr(ö|oe)(ß|ss)e|size/i.test(x.name); });
    if (!o && line.options_with_values && line.options_with_values.length) o = line.options_with_values[0];
    return o ? o.value : null;
  }
  function findUpgrade(cart) {
    var ids = cart.items.map(function (i) { return i.product_id; });
    for (var n = 0; n < cart.items.length; n++) {
      var line = cart.items[n];
      if (line.variant_id === giftId) continue;
      /* Set aus dem Produkt-Hinweis (custom.set_hinweis) zuerst prüfen */
      var reihe = SETS.slice().sort(function (a, b) {
        var pa = (a.bevorzugt || []).indexOf(line.product_id) > -1 ? 0 : 1;
        var pb = (b.bevorzugt || []).indexOf(line.product_id) > -1 ? 0 : 1;
        return pa - pb;
      });
      for (var s = 0; s < reihe.length; s++) {
        var set = reihe[s];
        if (ids.indexOf(set.id) > -1) continue;
        var idx = set.map[String(line.product_id)];
        if (idx === undefined) continue;
        var andere = Object.keys(set.map).filter(function (k) { return k !== String(line.product_id); });
        if (andere.some(function (k) { return ids.indexOf(parseInt(k, 10)) > -1; })) continue;
        var mehr = set.price - line.final_price;
        if (mehr <= 0) continue;
        return { line: line, set: set, idx: idx, size: sizeOf(line), mehr: mehr };
      }
    }
    return null;
  }
  function renderSetUpgrade(cart) {
    if (!elSet) return false;
    upgrade = findUpgrade(cart);
    if (!upgrade) { elSet.hidden = true; elSet.innerHTML = ''; return false; }
    var u = upgrade, set = u.set;
    var selects = set.options.map(function (name, i) {
      if (i === u.idx) return '';
      var werte = [];
      set.variants.forEach(function (v) { if (werte.indexOf(v.o[i]) === -1) werte.push(v.o[i]); });
      return '<label class="setup-field"><span>' + esc(name) + '</span><select data-set-opt="' + i + '">' +
        werte.map(function (w) { return '<option' + (w === u.size ? ' selected' : '') + '>' + esc(w) + '</option>'; }).join('') +
        '</select></label>';
    }).join('');
    elSet.innerHTML = '<span class="kicker">' + esc(T.setKicker) + '</span>' +
      '<div class="upsell">' +
        (set.image ? '<a href="' + esc(set.url) + '" class="line-img"><img src="' + esc(set.image) + '" alt="' + esc(set.title) + '" width="80" height="100" loading="lazy"></a>' : '<span></span>') +
        '<div class="line-info">' +
          '<a href="' + esc(set.url) + '" class="line-title">' + esc(set.title) + '</a>' +
          '<span class="line-opts">' + esc(set.label) + '</span>' +
          '<span class="setup-price">' + fill(T.setMore, money(u.mehr)) + (set.saving ? ' · ' + esc(String(T.setSaving).replace('[betrag]', set.saving)) : '') + '</span>' +
          (selects ? '<div class="setup-fields">' + selects + '</div>' : '') +
          '<button type="button" class="btn btn-primary btn-full" data-set-upgrade>' + esc(T.setButton) + '</button>' +
        '</div>' +
      '</div>';
    elSet.hidden = false;
    return true;
  }
  if (elSet) {
    elSet.addEventListener('click', function (e) {
      var b = e.target.closest('[data-set-upgrade]');
      if (!b || busy || !upgrade) return;
      var u = upgrade;
      var wahl = u.set.options.map(function (_, i) {
        if (i === u.idx) return u.size;
        var s = elSet.querySelector('[data-set-opt="' + i + '"]');
        return s ? s.value : null;
      });
      var v = u.set.variants.find(function (x) { return x.o.every(function (w, i) { return w === wahl[i]; }); });
      if (!v || !v.a) { alertInline({ message: T.comboSold }); return; }
      busy = true;
      b.setAttribute('aria-busy', 'true');
      api('/cart/change.js', { id: u.line.key, quantity: u.line.quantity - 1 })
        .then(function () { return api('/cart/add.js', { items: [{ id: v.id, quantity: 1 }] }); })
        .then(getCart).then(syncGift).then(getCart).then(render)
        .catch(function (err) { refresh().then(function () { alertInline(err); }); })
        .then(function () { busy = false; });
    });
  }

  function render(cart) {
    renderProgress(cart);
    renderItems(cart);
    if (renderSetUpgrade(cart)) { elUpsell.hidden = true; upsellFor = null; } else { renderUpsell(cart); }
    if (elTotal) elTotal.textContent = money(cart.total_price);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      var n = cart.items.reduce(function (a, i) { return a + (i.variant_id === giftId ? 0 : i.quantity); }, 0);
      el.textContent = n;
    });
    return cart;
  }

  function refresh() {
    return getCart().then(syncGift).then(function (c) { return c && c.items ? c : getCart(); }).then(render);
  }

  /* ── Mengen ändern ── */
  elItems.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b || busy) return;
    var key = b.closest('[data-key]').getAttribute('data-key');
    busy = true;
    api('/cart/change.js', { id: key, quantity: parseInt(b.getAttribute('data-qty'), 10) })
      .then(syncGift).then(getCart).then(render)
      .catch(function (err) { alertInline(err); })
      .then(function () { busy = false; });
  });

  /* ── Upsell hinzufügen ── */
  elUpsell.addEventListener('click', function (e) {
    var b = e.target.closest('[data-upsell-add]');
    if (!b || busy) return;
    var v = elUpsell.querySelector('[data-upsell-variant]');
    busy = true;
    add([{ id: parseInt(v.value, 10), quantity: 1 }]).then(function () { busy = false; });
  });

  function alertInline(err) {
    var msg = (err && (err.description || err.message)) || T.error;
    var p = document.createElement('p');
    p.className = 'form-errors';
    p.textContent = msg;
    elItems.prepend(p);
    setTimeout(function () { p.remove(); }, 5000);
  }

  function add(items) {
    return api('/cart/add.js', { items: items })
      .then(getCart).then(syncGift).then(getCart).then(render)
      .then(open)
      .catch(function (err) { refresh().then(open).then(function () { alertInline(err); }); });
  }
  window.nullFuenfElfCart = { add: add, open: open, refresh: refresh };

  /* ── Produktformulare per AJAX ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    add([{ id: parseInt(idInput.value, 10), quantity: 1 }]).then(function () {
      if (btn) btn.removeAttribute('aria-busy');
    });
  });

  /* ── "Passt dazu"-Karten auf der Produktseite ── */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    var card = b.closest('[data-quick-card]');
    var v = card && card.querySelector('[data-quick-variant]');
    if (!v) return;
    b.setAttribute('aria-busy', 'true');
    add([{ id: parseInt(v.value, 10), quantity: 1 }]).then(function () { b.removeAttribute('aria-busy'); });
  });

  /* Beim Laden: Beigabe prüfen, Zähler setzen */
  refresh();
})();
